import { CONTACTS } from "@shared/config/seo-schemas";

/** Код рекламного клика, пойманного на входе на сайт */
export const ATTRIBUTION_CODE_KEY = "polotno_attr_code";

/**
 * Метрика привязывает офлайн-конверсию к визиту не старше 21 дня, поэтому
 * держать код дольше бессмысленно: он всё равно не сконвертируется, зато
 * помешает сохранить свежий клик.
 */
const MAX_AGE_MS = 21 * 24 * 60 * 60 * 1000;

interface StoredAttribution {
  code: string;
  ts: number;
}

const clear = (): void => {
  try {
    localStorage.removeItem(ATTRIBUTION_CODE_KEY);
  } catch {
    // приватный режим — молча деградируем
  }
};

export const readAttributionCode = (): string | null => {
  try {
    const raw = localStorage.getItem(ATTRIBUTION_CODE_KEY);
    if (!raw) {
      return null;
    }

    const stored = JSON.parse(raw) as Partial<StoredAttribution>;
    if (!stored?.code || typeof stored.ts !== "number") {
      clear();
      return null;
    }

    if (Date.now() - stored.ts > MAX_AGE_MS) {
      clear();
      return null;
    }

    return stored.code;
  } catch {
    clear();
    return null;
  }
};

export const saveAttributionCode = (code: string): void => {
  try {
    const stored: StoredAttribution = { code, ts: Date.now() };
    localStorage.setItem(ATTRIBUTION_CODE_KEY, JSON.stringify(stored));
  } catch {
    // приватный режим — молча деградируем
  }
};

/**
 * Ссылка на бота с меткой источника. Без неё переход «реклама → сайт → бот»
 * теряется: бот получает /start без payload и связать его с кликом нечем.
 */
export const buildBotUrl = (): string => {
  const code = readAttributionCode();
  return code ? `${CONTACTS.transcribeBotUrl}?start=${code}` : CONTACTS.transcribeBotUrl;
};
